/* Outdoor Power LLC storefront helpers: instant search, "Will it fit?" and the parts helper chat. */
(function () {
  var API = 'https://api.outdoorpowerllc.net/v1/';
  var esc = function (s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); };
  var money = function (p) { return '$' + Number(p).toFixed(2); };
  var get = function (path) { return fetch(API + path).then(function (r) { if (!r.ok) throw 0; return r.json(); }); };

  function addToCart(variant, btn, label) {
    btn.disabled = true;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(variant), quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw 0; return fetch('/cart.js'); }).then(function (r) { return r.json(); })
      .then(function (c) {
        btn.textContent = 'Added ✓';
        Array.prototype.forEach.call(document.querySelectorAll('.cart-count, .cart-badge--desktop'), function (el) { el.textContent = c.item_count; el.classList.remove('hidden-count'); });
      }).catch(function () { btn.textContent = 'Try again'; }).then(function () { btn.disabled = false; });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-op-add]');
    if (b) { e.preventDefault(); addToCart(b.getAttribute('data-op-add'), b); }
  });

  function partRow(p) {
    return '<div class="op-row">' + (p.image ? '<img src="' + esc(p.image + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=96') + '" alt="" loading="lazy">' : '<span class="op-noimg"></span>') +
      '<a class="op-row-main" href="' + esc(p.url) + '"><b>' + esc(p.sku) + '</b><span>' + esc(p.title) + '</span>' +
      (p.why && p.why.indexOf('replaces') === 0 ? '<em>' + esc(p.why) + '</em>' : '') + '</a>' +
      '<span class="op-price">' + money(p.price) + '</span>' +
      (p.variant ? '<button class="op-add" data-op-add="' + p.variant + '">Add</button>' : '') + '</div>';
  }

  /* ---------------- instant search under the header search box ---------------- */
  function instantSearch(input) {
    var box = document.createElement('div'); box.className = 'op-suggest'; box.hidden = true;
    input.parentNode.style.position = 'relative'; input.parentNode.appendChild(box); input.setAttribute('autocomplete', 'off');
    var t, last = '';
    input.addEventListener('input', function () {
      clearTimeout(t); var q = input.value.trim();
      if (q.length < 2) { box.hidden = true; return; }
      t = setTimeout(function () {
        last = q;
        get('search?q=' + encodeURIComponent(q)).then(function (r) {
          if (q !== last) return;
          var h = '';
          if (r.machines.length) h += '<div class="op-sec">Machines</div>' + r.machines.map(function (m) { return '<a class="op-mach" href="' + esc(m.url) + '">' + esc(m.brand + ' ' + m.model) + ' <span>' + esc(m.name) + '</span></a>'; }).join('');
          if (r.parts.length) h += '<div class="op-sec">Parts</div>' + r.parts.slice(0, 6).map(partRow).join('');
          if (r.guides.length) h += '<div class="op-sec">How-to guides</div>' + r.guides.map(function (g) { return '<a class="op-mach" href="' + esc(g.url) + '">' + esc(g.title) + '</a>'; }).join('');
          h += '<a class="op-all" href="/search?type=product&q=' + encodeURIComponent(q) + '">See all results for "' + esc(q) + '" &rarr;</a>';
          box.innerHTML = h; box.hidden = false;
        }).catch(function () { box.hidden = true; });
      }, 180);
    });
    document.addEventListener('click', function (e) { if (!box.contains(e.target) && e.target !== input) box.hidden = true; });
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') box.hidden = true; });
  }

  /* ---------------- "Will it fit my machine?" on product pages ---------------- */
  function fitBox(el) {
    var sku = el.getAttribute('data-sku'); if (!sku) return;
    el.innerHTML = '<h3>Will it fit my machine?</h3><form class="op-fit-form"><input name="model" placeholder="Model # (e.g. 74022)" required>' +
      '<input name="serial" placeholder="Serial # (optional)"><button>Check</button></form><div class="op-fit-out"></div><div class="op-fit-list"></div>';
    el.hidden = false;
    var out = el.querySelector('.op-fit-out');
    el.querySelector('form').onsubmit = function (e) {
      e.preventDefault(); var f = e.target; out.textContent = 'Checking…';
      get('fits?sku=' + encodeURIComponent(sku) + '&model=' + encodeURIComponent(f.model.value) + '&serial=' + encodeURIComponent(f.serial.value)).then(function (r) {
        var cls = r.answer === 'yes' ? 'yes' : r.answer === 'no' ? 'no' : 'unk';
        var icon = r.answer === 'yes' ? '✓ ' : r.answer === 'no' ? '✕ ' : '? ';
        out.innerHTML = '<div class="op-fit-' + cls + '">' + icon + esc(r.message) + '</div>' +
          (r.machine ? '<a href="' + esc(r.machine.url) + '">See all parts for the ' + esc(r.machine.brand + ' ' + r.machine.model) + ' &rarr;</a>' : '') +
          (r.answer !== 'yes' ? ' <a href="/pages/contact?part=' + encodeURIComponent(sku) + '&model=' + encodeURIComponent(f.model.value) + '">Ask a parts expert</a>' : '');
      }).catch(function () { out.textContent = 'Could not check right now. Please try again.'; });
    };
    get('fits?sku=' + encodeURIComponent(sku)).then(function (r) {
      if (!r.machines || !r.machines.length) return;
      el.querySelector('.op-fit-list').innerHTML = '<div class="op-fit-head">Listed for these machines:</div>' + r.machines.slice(0, 12).map(function (m) {
        return '<a href="' + esc(m.url) + '">' + esc(m.brand + ' ' + m.model) + '</a>';
      }).join('') + (r.machines.length > 12 ? '<span>+' + (r.machines.length - 12) + ' more</span>' : '');
    }).catch(function () {});
  }

  /* ---------------- parts helper chat ---------------- */
  function md(s) {  // tiny, safe markdown: links, bold, bullet lines
    s = esc(s).replace(/\[([^\]]+)\]\((\/[^)\s]+)\)/g, '<a href="$2">$1</a>')
      .replace(/(^|\s)(\/(?:products|pages|collections|blogs)\/[A-Za-z0-9\-_/?=&.%]+)/g, '$1<a href="$2">$2</a>')
      .replace(/\*\*([^*]+)\*\*/g, '<b>$1</b>');
    return s.split(/\n/).map(function (l) { return /^\s*[-•]\s+/.test(l) ? '<li>' + l.replace(/^\s*[-•]\s+/, '') + '</li>' : l + '<br>'; }).join('').replace(/(<li>.*?<\/li>)+/g, '<ul>$&</ul>');
  }
  function chat() {
    var msgs = [];
    var wrap = document.createElement('div'); wrap.className = 'op-chat';
    wrap.innerHTML = '<button class="op-chat-btn" aria-label="Parts helper">Parts help?</button>' +
      '<div class="op-chat-panel" hidden><div class="op-chat-head">Parts Helper<button class="op-chat-x" aria-label="Close">×</button></div>' +
      '<div class="op-chat-log"><div class="op-msg bot">Hi! Ask me if a part fits your machine, look up a part number, or tell me your model and what you need.</div></div>' +
      '<form class="op-chat-form"><input placeholder="e.g. Will 133-7076 fit my 74022?" maxlength="500"><button>Send</button></form>' +
      '<div class="op-chat-foot">Need a person? <a href="/pages/contact">Contact our parts team</a></div></div>';
    document.body.appendChild(wrap);
    var panel = wrap.querySelector('.op-chat-panel'), log = wrap.querySelector('.op-chat-log'), input = wrap.querySelector('input');
    wrap.querySelector('.op-chat-btn').onclick = function () { panel.hidden = !panel.hidden; if (!panel.hidden) input.focus(); };
    wrap.querySelector('.op-chat-x').onclick = function () { panel.hidden = true; };
    function say(cls, html) { var d = document.createElement('div'); d.className = 'op-msg ' + cls; d.innerHTML = html; log.appendChild(d); log.scrollTop = log.scrollHeight; return d; }
    wrap.querySelector('form').onsubmit = function (e) {
      e.preventDefault(); var q = input.value.trim(); if (!q) return; input.value = '';
      say('me', esc(q)); msgs.push({ role: 'user', content: q });
      var wait = say('bot', '<span class="op-dots">…</span>');
      fetch(API + 'chat', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ messages: msgs }) })
        .then(function (r) { if (r.status === 429) throw 'busy'; return r.json(); })
        .then(function (r) {
          msgs.push({ role: 'assistant', content: r.reply });
          var h = md(r.reply);
          if (r.results) {
            if (r.results.machines && r.results.machines.length) h += r.results.machines.map(function (m) { return '<a class="op-mach" href="' + esc(m.url) + '">Parts for the ' + esc(m.brand + ' ' + m.model) + ' &rarr;</a>'; }).join('');
            if (r.results.parts && r.results.parts.length) h += r.results.parts.slice(0, 5).map(partRow).join('');
            if (r.results.guides && r.results.guides.length) h += r.results.guides.map(function (g) { return '<a class="op-mach" href="' + esc(g.url) + '">' + esc(g.title) + '</a>'; }).join('');
          }
          wait.innerHTML = h;
          log.scrollTop = log.scrollHeight;
        }).catch(function (err) { wait.innerHTML = err === 'busy' ? 'Lots of questions right now - please try again in a minute.' : 'Sorry, something went wrong. Please try again.'; });
    };
    document.documentElement.classList.add('op-chat-on');  // hides the default chat bubble
  }

  get('health').then(function () {
    Array.prototype.forEach.call(document.querySelectorAll('.site-header input[name="q"], .mobile-nav input[name="q"]'), instantSearch);
    Array.prototype.forEach.call(document.querySelectorAll('[data-op-fit]'), fitBox);
    chat();
  }).catch(function () { /* API unreachable: leave the store exactly as it is */ });
})();
